import React from "react"

const Dashboard = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h2>Admin Dashboard</h2>

      <div
        style={{
          marginTop: "20px",
          padding: "15px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <h3>Info</h3>
        <p>
          You can manage and add blog posts directly in Strapi. Go to the
          following URL:
        </p>
        <p>
          <a
            href='http://145.223.23.32:1337/admin'
            target='_blank'
            rel='noopener noreferrer'
          >
            Strapi Admin Panel
          </a>
        </p>
        <p>Use the following credentials to log in:</p>
        <ul>
          <li>
            <strong>Email:</strong> psrco120@gmail.com
          </li>
          <li>
            <strong>Password:</strong> csRamIndore123@
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Dashboard
